import React, { useEffect } from 'react'
import PDFObject from 'pdfobject'
import consentPdf from 'static/consent-uams-htn.pdf'

const consentHtml = require('html-loader!static/consent-uams-htn.html') // eslint-disable-line import/no-webpack-loader-syntax
const consentHtmlObj = { __html: consentHtml }

export default function ConsentForm () {
  const showPdf = !!(PDFObject.supportsPDFs)

  useEffect(() => {
    if (showPdf) {
      PDFObject.embed(consentPdf, '#tos-container')
    }
  }, [showPdf])

  const renderConsentForm = () => {
    // Fall back to displaying our amazingly crufty HTML consent
    if (!showPdf) {
      return (
        <div id='tos-container' style={{ height: '100%', width: '100%' }} dangerouslySetInnerHTML={consentHtmlObj} />
      )
    }

    return (<div id='tos-container' style={{ height: '100%', width: '100%' }} />)
  }

  return renderConsentForm()
}
